const filterCurationReward = (t, value) => {
    value = value.toLowerCase();
    return t.authorPerm.toLowerCase().includes(value);
};
const filterTransfer = (t, value) => {
    var _a;
    value = value.toLowerCase();
    return (t.to.toLowerCase().includes(value) ||
        t.from.toLowerCase().includes(value) ||
        ((_a = t.memo) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(value)));
};
const filterStake = (t, value) => {
    value = value.toLowerCase();
    return (t.to.toLowerCase().includes(value) || t.from.toLowerCase().includes(value));
};
const filterDelegation = (t, value) => {
    value = value.toLowerCase();
    return (t.delegator.toLowerCase().includes(value) ||
        t.delegatee.toLowerCase().includes(value));
};
const filterMiningLottery = (t, value) => {
    value = value.toLowerCase();
    return t.poolId.toLowerCase().includes(value);
};
export const TokenTransactionUtils = {
    filterTransfer,
    filterStake,
    filterDelegation,
    filterCurationReward,
    filterMiningLottery,
};
